// extracted by mini-css-extract-plugin
export default {"playBtn":"PlayAllButton_playBtn__uwsKj"};